import i18n from '@/i18n'
import { MonthStatisticResponse, MonthStatisticResponseItem } from '@/types/service-response'

export class MonthStatistic {
  private constructor (
    readonly employeeId: number,
    readonly employee: string,
    readonly planningGroupId: number,
    readonly planningGroup: string,
    readonly BG_STD: string,
    readonly BG: string,
    readonly Planung_STD: string,
    readonly Planung: string,
    readonly Planung_Samstag: string,
    readonly Planung_Sonntage: string,
    readonly Planung_Urlaub: string
  ) {}

  public static createFromResponse (data: MonthStatisticResponse): MonthStatistic[] {
    return data.map((item: MonthStatisticResponseItem): MonthStatistic => {
      return new MonthStatistic(
        item.MitarbeiterID,
        item.MitarbeiterName,
        item.Planungsgruppe,
        item.Springer ? i18n.t('monthStatistic.floater').toString() : item.PlanungsgruppeBezeichnung,
        parseFloat(item.BG_STD.toString()).toFixed(2).toString(),
        `${item.BG.toString()} %`,
        parseFloat(item.Planung_STD.toString()).toFixed(2).toString(),
        `${parseFloat(item.Planung.toString()).toFixed(2).toString()} %`,
        `${item.Planung_Samstag.toString()} ${i18n.t('monthStatistic.days').toString()}`,
        `${item.Planung_Sonntage.toString()} ${i18n.t('monthStatistic.days').toString()}`,
        `${item.Planung_Urlaub.toString()} ${i18n.t('monthStatistic.days').toString()}`
      )
    })
  }
}
